import { QueryParameters } from "@faire/web-api--source/endpoints/www/api/exclusivity-agreements/retailers/retailerToken/availability/get";

export const buildExclusivityQueryParams = (brandToken: string | undefined) => {
  return QueryParameters.build({
    brand_token: brandToken,
    include_options: true,
  });
};
